export default {
  today: 'Danas',
  now: 'Sada',
  backToToday: 'Vrati se na danas',
  ok: 'U redu',
  clear: 'ObriÅ¡i',
  month: 'Mesec',
  year: 'Godina',
  timeSelect: 'Izaberi vreme',
  dateSelect: 'Izaberi datum',
  monthSelect: 'Izaberi mesec',
  yearSelect: 'Izaberi godinu',
  decadeSelect: 'Izaberi deceniju',
  yearFormat: 'YYYY',
  dateFormat: 'DD.MM.YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Prethodni mesec (PageUp)',
  nextMonth: 'SledeÄi mesec (PageDown)',
  previousYear: 'Prethodna godina (Control + left)',
  nextYear: 'SledeÄa godina (Control + right)',
  previousDecade: 'Prethodna decenija',
  nextDecade: 'SledeÄa decenija',
  previousCentury: 'Prethodni vek',
  nextCentury: 'SledeÄi vek',
};
